import { simulatorBackend } from '@/application/api';

export const getDocumentList = async () => {
  const response = await simulatorBackend.get('/document-list');
  return response.data;
};
